import { extractLayout, extractBlocks } from './renderContent';

export { extractLayout, extractBlocks };
